import { Controller } from "@hotwired/stimulus"
import * as dateUtils from '../../packs/date_utils'
import * as strftime from 'strftime';

export default class extends Controller {
  static targets = ["startDate", "endDate", "durationDay", "pricingId"]
  static values = {
    includeStartDateOnDuration: { type: Boolean, default: false },
    onDurationMode: Boolean
  }

  connect() {
    if (this.onDurationModeValue) {
      $(this.startDateTarget).on("change", () => this.changeEndDate())
    } else {
      if (this.startDateTarget.value != "" && this.endDateTarget.value != "") {
        this.writeDuration()
      }

      $(this.startDateTarget).on("change", () => {
        dateUtils.adjustStartLimit($(this.startDateTarget), $(this.endDateTarget), 0);

        if(this.endDateTarget.value != "") {
          this.writeDuration()
        }
      })

      $(this.endDateTarget).on("change", () => {
        dateUtils.adjustFinishLimit($(this.startDateTarget), $(this.endDateTarget), 0);

        if(this.startDateTarget.value != "") {
          this.writeDuration()
        }
      })
    }
  }

  changeEndDate() {
    if (this.startDateTarget.value === "" || this.pricingIdTarget.value === "") return

    const finishCandidate = dateUtils.dateFromStringShort(this.startDateTarget.value)
    const selectedPricingIndex = this.pricingIdTarget.selectedIndex
    const selectedPricingOption = this.pricingIdTarget.options[selectedPricingIndex]
    const durationDay = parseInt(selectedPricingOption.dataset.durationDay, 10)

    if (isNaN(durationDay)) return

    const startDateOffset = this.includeStartDateOnDurationValue ? -1 : 0;
    finishCandidate.setDate(finishCandidate.getDate() + startDateOffset + durationDay);

    this.endDateTarget.value = strftime("%e-%b-%Y", finishCandidate)
    this.endDateTarget.classList.remove("d-none")
  }

  writeDuration() {
    const startDate = dateUtils.dateFromStringShort(this.startDateTarget.value)
    const endDate = dateUtils.dateFromStringShort(this.endDateTarget.value)

    if (startDate && endDate) {
      const period = dateUtils.daysBetween(startDate, endDate)
      this.durationDayTarget.value = `${this.includeStartDateOnDurationValue ? (period + 1) : period} hari`
    }
  }

  // Ensure quantity value filled with value 1 if empty
  fixedQuantityValue(event) {
    const value = parseInt(event.currentTarget.value)
    event.currentTarget.value = isNaN(value) || value === 0 ? 1 : value
  }

  updatePricingOptions(event) {
    const currentValue = parseInt(event.currentTarget.value)
    const quantity = isNaN(currentValue) || currentValue === 0 ? 1 : currentValue
    const selectedPricing = this.pricingIdTarget.selectedIndex
    const newOptions = [...this.pricingIdTarget.options].map((option, index) => {
      const value = option.value
      const durationDay = option.dataset.durationDay
      const price = parseInt(option.dataset.price)
      const onDiscount = option.dataset.onDiscount
      const formattedPrice = (price * quantity).toLocaleString("id-ID")
      const discountLabel = onDiscount === "true" ? "Harga diskon!" : ""
      const optionElement = document.createElement("option")

      optionElement.value = value
      optionElement.text = `${durationDay} hari - Rp${formattedPrice} ${discountLabel}`
      optionElement.setAttribute("data-duration-day", durationDay)
      optionElement.setAttribute("data-price", price)
      optionElement.setAttribute("data-on-discount", onDiscount)

      if (index === selectedPricing) {
        optionElement.setAttribute("selected", "selected")
      }

      return optionElement
    })

    // Remove old select options
    Array.from(this.pricingIdTarget.options).forEach(option => option.remove())

    // Add new select options
    newOptions.forEach(option => {
      this.pricingIdTarget.add(option)
    })
  }
}
